<template>
  <div :class="{ 'form-fullScreen': isEdit }">
    <div v-show="!dialogFormVisible">
      <!-- <div class="filter-container">
        <div class="filter-box">
          <el-button
            v-permission="{pkey:`${permissionName}_ADD`}"
            class="filter-item"
            type="primary"
            :size="t('table.btnSize')"
            @click="handleCommand('add')"
          >
           申请外包费
          </el-button>
        </div>
      </div> -->
      <TableList
        ref="TableList"
        v-loading="listLoading"
        :dataList="list"
        :total="total"
        :columnAllData="columnAllData"
        :tableName="TableName"
        :permissionName="permissionName"
        :showSelection="false"
        :canRefresh="false"
        :canChangeColumn="false"
        :isShowPagination="false"
        :canCommand="true"
        :showSummary="true"
        :handleDefaultWidth="160"
        :maxHight="224"
        @command-change="handleCommand"
      >
        <template v-slot:operation-action="scope">
          <el-link
            v-if="scope.row.editable"
            v-permission="{ pkey: `${permissionName}_EDIT` }"
            href="javascript:void(0);"
            class="mr-10"
            type="primary"
            @click="handleCommand('edit', scope.row)"
          >
            编辑
          </el-link>
          <el-link
            v-if="scope.row.deletable"
            v-permission="{ pkey: `${permissionName}_DELETE` }"
            href="javascript:void(0);"
            class="mr-10"
            type="danger"
            @click="handleCommand('delete', scope.row)"
          >
            删除
          </el-link>
          <el-link
            v-if="Number(scope.row.paid || 0) > 0"
            v-permission="{ pkey: `${permissionName}_ADD` }"
            href="javascript:void(0);"
            type="warning"
            @click="handleCommand('refund-apply', scope.row)"
          >
            {{ scope.row.status === '退款中' ? '修改退款申请' : '申请退款' }}
          </el-link>
        </template>
      </TableList>
    </div>
     <FormComponent
      v-if="dialogFormVisible"
      :id="activeId"
      :businessDetail="businessDetail"
      :dialogFormVisible="dialogFormVisible"
      :api="'outsourceFee'"
      :handleResolveTempData="handleResolveTempData"
      @update:visibel="dialogFormVisible = false;isEdit = false"
      @submit="handleSubmit(formData);isEdit = false"
    />
    <el-dialog
      v-if="refundVisible"
      v-model="refundVisible"
      title="申请外包费退款"
      width="420px"
    >
      <el-form :model="refundForm" label-position="top">
        <el-form-item label="当前可退已付净额">
          <span>¥{{ activeRow.paid }}</span>
        </el-form-item>
        <el-form-item label="申请退款金额">
          <el-input-number
            v-model="refundForm.amount"
            :min="0.01"
            :max="Number(activeRow.paid)"
            :precision="2"
            controls-position="right"
            style="width: 100%"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="refundVisible = false">取消</el-button>
        <el-button type="primary" @click="submitRefundApply">确定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script lang='ts'>
import { defineComponent, reactive, toRefs, onMounted, ref, watch } from 'vue'
import { ElForm, ElMessage, ElMessageBox } from 'element-plus'
import { getOutsourceFeeList, refundApply } from '@/apis/OutsourceFee'
import { getDropdown, deleteById } from '@/apis/Dictionary'
import { getDropdownByType } from '@/apis/tool'

import { CostModel } from '@/model/Index'
import FormComponent from './Form.vue'
import TableList from '@/components/common/TableList.vue'
import { TableName, permissionName } from '@/utils/enum'
import { TableField } from './FieldTable'
import { pageVo, pageSizes } from '@/utils/index'

import { useI18n } from 'vue-i18n'
export default defineComponent({
  name: 'Outsourcefee',
  components: {
    FormComponent,
    TableList
  },
  props: {
    id: { type: Number, required: true, default: 0 },
    businessDetail: { type: Object, required: true, default: () => null }

  },
  setup(props) {
    const { t } = useI18n()
    const TableList = ref(null)
    const setForm = ref(ElForm)

    const dataMap = reactive({
      TableName: TableName.TABLE_OUTSOURCE_BUSINESS_FEE,
      permissionName: permissionName.OUTSOURCE_BUSINESS_FEE,
      columnAllData: TableField,

      activeId: 0,
      list: [],
      total: 0,
      listLoading: false,
      listQuery: {
        name: undefined,
        phone: undefined,
        ...pageVo
      },
      pageSizes,
      dialogFormVisible: false,
      layouts: [
        { x: 0, y: 0, w: 12, h: 6, i: '0' }
      ],
      salesManOption: [],
      setEnableVisible: false,
      setEnableForm: {
        taxType: ''
      },
      setEnableRules: {
        rate: [{ required: true, message: '请填写必填项', trigger: ['change', 'blur'] }]
      },
      submitLoading: false,
      viewPayVisible: false,
      isEdit: false,
      refundVisible: false,
      activeRow: {} as any,
      refundForm: {
        amount: 0
      },

      handleCommand(command: string, val?: any) {
        switch (command) {
          case 'add':
            dataMap.handleCreate()
            dataMap.isEdit = true
            break
          case 'edit':
            dataMap.activeId = val.id
            dataMap.handleUpdate()
            break
          case 'delete':
            dataMap.handleDelete(val)
            break
          case 'refund-apply':
            dataMap.activeRow = val
            dataMap.refundForm.amount = Number(val.refundApplyAmount) > 0 ? Number(val.refundApplyAmount) : Number(val.paid)
            dataMap.refundVisible = true
            break
          case 'refresh':
            dataMap.handleFilter()
            break
          case 'column':
            ;(TableList.value as any).setColumnVisible = true
            break
          case 'current-change':
            dataMap.handleCurrentChange(val)
            break
          case 'size-change':
            dataMap.handleSizeChange(val)
            break
        }
      },
      submitRefundApply() {
        refundApply({
          id: dataMap.activeRow.id,
          amount: dataMap.refundForm.amount
        }).then(() => {
          ElMessage.success('申请成功')
          dataMap.refundVisible = false
          dataMap.getList()
        })
      },
      getList() {
        if (!props.id) {
          dataMap.list = []
          return
        }
        dataMap.listLoading = true
        getOutsourceFeeList(props.id).then((res: any) => {
          dataMap.list = res || []
          dataMap.listLoading = false
        }).catch(() => {
          dataMap.listLoading = false
        })
      },
      handleReset() {
        dataMap.listQuery = {
          name: undefined,
          phone: undefined,
          ...pageVo
        }
        dataMap.handleFilter()
      },
      handleFilter() {
        dataMap.getList()
      },

      handleCreate() {
        dataMap.activeId = 0
        dataMap.dialogFormVisible = true
      },
      handleUpdate() {
        dataMap.isEdit = true
        dataMap.dialogFormVisible = true
      },
      handleDelete(row: any) {
        ElMessageBox.confirm(
          '确定要删除选中数据吗？',
          '删除',
          {
            confirmButtonText: t('table.confirm'),
            cancelButtonText: t('table.cancel'),
            type: 'warning',
            cancelButtonClass: 'el-button--danger'
          }
        )
          .then(() => {
            deleteById('outsourceFee', row.id).then(() => {
              dataMap.getList()
              ElMessage({
                message: '删除成功',
                type: 'success',
                duration: 1000
              })
            })
          })
      },
      handleSubmit() {
        dataMap.getList()
      },
      handleCurrentChange(page?: any) {
        dataMap.listQuery.page = page
        dataMap.getList()
      },
      handleSizeChange(size: any) {
        dataMap.listQuery.size = size
        dataMap.handleCurrentChange(1)
      },
      loadTableSelectOption() {
        dataMap.columnAllData.forEach((column: any) => {
          if (column.selectType === 2 && column.url) {
            getDropdown(column.url).then((res: any) => {
              column.option = res
                ? res.map((k: any) => {
                  return {
                    ...k,
                    name: k.mark
                  }
                })
                : []
            })
          } else if (column.selectType === 1 && column.url) {
            getDropdownByType(column.url).then((res: any) => {
              column.option = res
                ? res.map((k: any) => {
                  return {
                    ...k,
                    name: k.mark
                  }
                })
                : []
            })
          }
        })
      }
    })

    watch(() => props.id, () => {
      dataMap.getList()
    })

    onMounted(async() => {
      // await dataMap.loadTableSelectOption()
      dataMap.getList()
    })
    return { TableList, t, ...toRefs(dataMap), setForm }
  }
})
</script>
